import { useState } from "react";
import heroImage from "../assets/edit.jpg";

export default function HeroSection() {
  const [imageSrc, setImageSrc] = useState(
    "https://images.pexels.com/photos/29445973/pexels-photo-29445973.jpeg?cs=srgb&dl=pexels-peaky-29445973.jpg&fm=jpg",
  );

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen bg-[#0b0b0b] overflow-visible"
    >
      {/* Animated Background Glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,180,80,0.2),transparent_60%)] animate-pulse" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(0,200,200,0.15),transparent_70%)]" />

      {/* Animated Grid Pattern */}
      <div className="absolute left-10 top-40 opacity-5 animate-float">
        <div className="grid grid-cols-3 gap-2">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="h-10 w-10 border border-white/20 rounded-md hover:border-cyan-400 transition-colors"
            />
          ))}
        </div>
      </div>

      {/* Floating Circles */}
      <div className="absolute top-20 right-10 w-40 h-40 bg-cyan-400/10 rounded-full blur-3xl animate-float opacity-20" />
      <div
        className="absolute bottom-32 left-1/4 w-56 h-56 bg-orange-400/10 rounded-full blur-3xl animate-float opacity-20"
        style={{ animationDelay: "1s" }}
      />

      {/* Main Content */}
      <div className="relative z-10 mx-auto max-w-7xl px-6 pt-32 grid md:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* LEFT CONTENT */}
        <div className="animate-slide-left">
          <span className="inline-block mb-6 rounded-full glass-morphism px-4 py-2 text-sm text-white hover:scale-105 transition-transform">
            ✨ Himanshu Kushwaha
          </span>

          <h1 className="text-5xl md:text-7xl font-black text-white leading-tight bg-clip-text animate-fade">
            FULL STACK <br />
            <span className="bg-gradient-to-r from-orange-400 to-cyan-400 text-black px-2 rounded">
              DEVELOPER
            </span>
          </h1>

          <p
            className="mt-6 max-w-xl text-gray-400 text-lg leading-relaxed animate-fade"
            style={{ animationDelay: "0.2s" }}
          >
            Full-stack development isn't about knowing tools — it's about
            building systems end to end.
            <span className="font-medium text-transparent bg-gradient-to-r from-orange-300 to-cyan-300 bg-clip-text">
              {" "}
              Learn by shipping real products
            </span>{" "}
            with hands-on projects, collaborative code reviews, peer learning,
            and an active developer community.
          </p>

          {/* Buttons */}
          <div
            className="mt-8 flex gap-4 animate-fade"
            style={{ animationDelay: "0.4s" }}
          >
            <a
              href="https://github.com/himanshuji003"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block rounded-xl bg-gradient-to-r from-orange-400 to-cyan-400 px-6 py-3 text-black font-bold hover:scale-110 hover:shadow-[0_0_30px_rgba(255,180,80,0.5)] transition-all duration-300 shadow-lg"
            >
              GitHub ↗
            </a>

            <button
              onClick={() => scrollToSection("projects")}
              className="rounded-xl glass-morphism-hover px-6 py-3 text-white font-medium"
            >
              See The Impact ↓
            </button>
          </div>
        </div>

        {/* RIGHT MAIN IMAGE */}
        <div className="relative flex justify-center animate-slide-right z-10">
          <div className="absolute inset-0 bg-gradient-to-r from-orange-400/20 to-cyan-400/20 rounded-3xl blur-2xl"></div>

          {/* Updated Image Source below */}
          <img
            src={imageSrc}
            alt="Portfolio Hero"
            className="w-[180px] sm:w-[210px] md:w-[240px] lg:w-[270px] xl:w-[300px] rounded-3xl shadow-[0_35px_95px_rgba(0,0,0,0.75)] relative border border-white/10 hover:border-cyan-400/50 transition-all duration-300 hover:scale-105 z-20"
            onError={() => {
              if (imageSrc !== heroImage) {
                setImageSrc(heroImage);
              }
            }}
          />
        </div>
      </div>

      {/* Bottom Fade */}
      <div className="absolute bottom-0 left-0 w-full h-40 bg-gradient-to-t from-black to-transparent" />
    </section>
  );
}
